export const GET_DEVICE_ID = 'GET_DEVICE_ID';
